import { create } from 'zustand';
const useWarningStore = create()((set) => ({
    warning: '',
    setWarning: (warning) => set({ warning })
}));
export default useWarningStore;
